import React, { Component, Fragment, useState } from "react";

import { useNavigate } from "react-router";
import { useTranslation, I18nextProvider } from "react-i18next";


import { useDispatch } from "react-redux";

import { useCustomizeContext } from "../../context";
import 'react-loading-skeleton/dist/skeleton.css'


import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { getSearchGames } from "../../Features/GameCommon/gameCommonSlice";


const Search = (props) => {
    const { t, i18n } = useTranslation();

    let navigate = useNavigate();
    let dispatch = useDispatch();


    const {
        loader: {
            loading, setLoading,
        },
        languageContext: {
            language, setLanguage,
            changeLanguageRes, setChangeLanguageRes,
        },
        gameSearch: {
            searchGameRes, setGameSearchRes, searchIsActive, setSearchIsActive, searchText, setSearchText,
        }
    } = useCustomizeContext();


    var settings = {
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow: (<button type='button' class='slick-prev'><svg width='6' height='9' viewBox='0 0 6 9' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L5 4.5L1 8' stroke='white' /></svg></button>),
        nextArrow: (<button type='button' class='slick-next'><svg width='6' height='9' viewBox='0 0 6 9' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L5 4.5L1 8' stroke='white' /></svg></button>),
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,

                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,

                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    const clearSearch = async () => {
        setSearchIsActive(false);
        setSearchText("");
        let data = {
            gamename: ""
        }
        searchGame(data);
    }

    const searchGame = async (data) => {
        let gameRes = await dispatch(getSearchGames(data));
        if (gameRes?.status) {
            setGameSearchRes(gameRes?.data);
        }
        else {
            setGameSearchRes([]);
        }
    }

    return (
        <div class="searchresult-mainbox">
            <div class="searchresult-inrcnt">
                <h5>{t('Search result')}</h5>
                <div class="search-slider">
                    <a className="searchCloseIcon"><span onClick={clearSearch} >X</span></a>
                    <div class="slider multiple-items">
                        <Slider {...settings}>
                            {
                                searchGameRes?.length > 0 ?

                                    searchGameRes?.map((game, index) =>
                                        <div class="slider-item" key={index}>
                                            <img src={game?.gameIcon} alt="" style={{ cursor: "pointer" }} onClick={() => { navigate(game?.routes); setSearchIsActive(!searchIsActive) }} class="img-fluid" />
                                        </div>
                                    )
                                    :
                                    <div className="searchNoData">{t('No Game Found')}</div>
                            }
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Search;